import { LeadPriorityScore, SCORING_PRIORITIES } from "../types/lead-priority";
import type { ScoringConfigRule } from "../types/scoring-config";

export const getEnabledLeadScoreTiers = (rules: ScoringConfigRule): ReadonlySet<LeadPriorityScore> => {
    const enabled = new Set<LeadPriorityScore>();

    for (const priority of SCORING_PRIORITIES) {
        if ((rules[priority]?.length ?? 0) > 0) {
            enabled.add(priority);
        }
    }

    if (enabled.size > 0) {
        enabled.add(LeadPriorityScore.NoScore);
    }

    return enabled;
};
